<div class="error-page">
  <div class="error-page-inner">
    <span class="error-page-check material-icons">highlight_off</span>
    <h2>Er is iets fout gegaan.</h2>
  </div>
</div>
